import React, {useCallback, useEffect, useState} from "react";
import ajaxloader from "../../images/ajax-loader.gif";
import {Card, DropdownButton, FormCheck} from "react-bootstrap";
import AdminService from "../../services/admin.service";
import DropdownItem from "react-bootstrap/DropdownItem";
import {useDispatch, useSelector} from "react-redux";
import {loadAllClients, selectUserState} from "../../reducer/userSlice";
import Select from "react-select";
import {getClientOptions, toSelectOptions} from "../canopia/CanopiaUtils";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import {CheckSquareFill, Square} from "react-bootstrap-icons";
import MessageBox from "../core/MessageBox";

export default function Run(props) {

    const dispatch = useDispatch();

    const {allClients} = useSelector(selectUserState);
    // const {clientDates} = useSelector(selectDateState);

    const reviewTypes = ['POS_ID', 'ISIN_AND_NAME'];

    const [clientIds, setClientIds] = useState([]);
    const [date, setDate] = useState('');
    const [consensusOption, setConsensusOption] = useState(null);
    const [unpublish, setUnpublish] = useState(false);
    const [runType, setRunType] = useState('full_eval_initial_run');
    const [reviewType, setReviewType] = useState(reviewTypes[0]);
    const [reviewFileName, setReviewFileName] = useState('');
    const [skipReview, setSkipReview] = useState(false);
    const [notifyReviewer, setNotifyReviewer] = useState(false);

    // Options for dropdowns
    const [clientOptions, setClientOptions] = useState([]);
    const [dateOptions, setDateOptions] = useState([]);
    const [consensusOptions, setConsensusOptions] = useState([]);

    const [loadStatus, setLoadStatus] = useState("idle");
    const [loadMessage, setLoadMessage] = useState("");
    const [loading, setLoading] = useState(false);

    const [showModal, setShowModal] = useState(false);
    const [modalMessages, setModalMessages] = useState([]);
    const [modalClass, setModalClass] = useState("import_log_INFO");

    const [loadingClientDates, setLoadingClientDates] = useState(false);
    const [loadingConsensusList, setLoadingConsensusList] = useState(false);

    const [jobResults, setJobResults] = useState(null);
    const [dateMessages, setDateMessages] = useState(null);
    const [consensusMessages, setConsensusMessages] = useState(null);

    const [errorName, setErrorName] = useState(null);
    const [errors, setErrors] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);

    const load = useCallback(() => {
        dispatch(loadAllClients());
    }, [dispatch]);

    // Load all the clients to populate the dropdown (done only once)
    useEffect(() => {
        if (loadStatus === "idle") {
            setLoadStatus("pending");
            try {
                load();
            } catch (err) {
                setLoadStatus("error");
                setLoadMessage("An error occurred while loading the page");
            } finally {
                setLoadStatus("success");
            }
        }
    }, [loadStatus, load, dispatch]);

    useEffect(() => {
        setClientOptions(getClientOptions(allClients));
    }, [allClients]);

    const handleRun = (e) => {
        e.preventDefault();

        setLoading(true);
        setJobResults(null);
        setErrorName(null);
        setErrors(null);
        setErrorMessage(null);

        AdminService.run(clientIds, date.value, consensusOption.value, unpublish, runType, reviewType, reviewFileName, skipReview, notifyReviewer)
            .then(
                response => {
                    const respData = response.data;
                    if (respData) {

                        const jobRes = respData.data;
                        const results = jobRes.results;

                        let failed = results.filter(result => result.status === 'FAILED');

                        let warnings = results.filter(result => result.status === 'WARNING');
                        let nonBreakingErrors = warnings.filter(result => result.logs.some(message => message.key === 'NON_BREAKING_ERROR'));
                        let warn = warnings.filter(result => result.logs.some(message => message.key === 'WARN'));

                        let success = results.filter(result => result.status === 'SUCCESS');
                        let info = success.filter(result => result.logs.every(message => message.key === 'INFO'));

                        let modalClass;
                        let modMessages = [];
                        if (failed.length > 0) {
                            modMessages.push(failed.length + ' job(s) failed, see the logs for details');
                            modalClass = "import_log_ERROR";
                        }

                        if (nonBreakingErrors.length > 0) {
                            modMessages.push(nonBreakingErrors.length + ' job(s) contain(s) non-breaking errors, see the logs for details');
                            if (!modalClass) {
                                modalClass = "import_log_NON_BREAKING_ERROR";
                            }
                        }

                        if (warn.length > 0) {
                            modMessages.push(warn.length + ' job(s) contain(s) warnings, see the logs for details');
                            if (!modalClass) {
                                modalClass = "import_log_WARN";
                            }
                        }

                        if (info.length > 0) {
                            modMessages.push(info.length + ' successful job(s), see the logs for details');
                            if (!modalClass) {
                                modalClass = "import_log_INFO";
                            }
                        }

                        setModalClass(modalClass);
                        setModalMessages(modMessages);
                        setJobResults(jobRes);

                        setShowModal(true);
                    } else {
                        setJobResults(null);
                    }
                    // setMessages(response.data ? response.data.data : null);
                    setLoading(false);
                },
                error => {
                    setLoading(false);
                    processError(error);
                }
            );
    }

    const processError = (error) => {
        let response = error.response;

        let errorName;
        let errors;
        let errorMessage;
        if (response &&
            response.data &&
            response.data.error &&
            response.data.message) {
            errorName = response.data.error;
            errors = response.data.errors;
            errorMessage = response.data.message;
        } else {
            errorName = 'Service unavailable';
            errorMessage = 'We apologize for the inconvenience, our team is working on solving the issue. Please try to come back in a few minutes.\nThank you for your patience.';
            errors = '';
            if (error.message) {
                console.log(error.message);
            }
        }

        setErrorName(errorName);
        setErrors(errors);
        setErrorMessage(errorMessage);
    }

    const changeRunType = (val) => {
        setRunType(val);
    }

    function hideModal() {
        setShowModal(false);
    }

    const handleSelectClient = (clients, action) => {
        let tgtClientIds = [];
        clients.forEach(client => {
            tgtClientIds.push(client.value);
        });
        setClientIds(tgtClientIds);

        if (tgtClientIds.length === 0) {
            setDateOptions([]);
            setDate(null);
            return;
        }

        setLoadingClientDates(true);

        AdminService.loadClientDates({userClients: tgtClientIds})
            .then(response => {
                const clientDates = response.data.data;

                if (!clientDates || clientDates.length === 0) {
                    setDateMessages([{
                        key: "error",
                        value: tgtClientIds.length === 1 ? "No date found for this client, it seems like no portfolio has been added yet" : "No common date found for this client set"
                    }]);
                } else {
                    setDateMessages(null);
                }

                let optionsTmp = toSelectOptions(clientDates);

                setDateOptions(optionsTmp);
                if (optionsTmp.length > 0) {
                    let lastDate = optionsTmp[0];
                    setDate(lastDate);
                    refreshConsensusList(tgtClientIds, lastDate.value);
                }

                setLoadingClientDates(false);

            }, error => {
                setLoadingClientDates(false);
                // processError(error);
            });

    }

    function refreshConsensusList(clientIds, date) {
        setLoadingConsensusList(true);

        AdminService.loadConsensusList({userClients: clientIds, dateStr: date})
            .then(response => {

                let result = response.data.data;
                if (!result || result.length === 0) {
                    setConsensusMessages([{
                        key: "error",
                        value: clientIds.length === 1 ? "No consensus found for this client, it seems like no consensus of the given type exists" : "No common consensus found for this client set"
                    }]);
                } else {
                    setConsensusMessages(null);

                    let optionsTmp = [];

                    result.forEach(consensus => {
                        const consensusId = consensus.consensusId;
                        const type = consensus.type;
                        const name = consensus.name;
                        const option = {value: consensusId, label: consensusId + ' (' + name + ', ' + type + ')'};
                        optionsTmp.push(option);
                    });

                    setConsensusOptions(optionsTmp);
                    if (optionsTmp.length > 0) {
                        let lastConsensus = optionsTmp[0];
                        setConsensusOption(lastConsensus);
                    }
                }

                setLoadingConsensusList(false);
            }, error => {
                setLoadingConsensusList(false);
            });
    }

    const handleDateChange = (date, action) => {

        let dateValue;
        switch (action.action) {
            case 'create-option':
                dateValue = date ? date.value.trim() : null;
                if (dateValue) {
                    let tmpOptions = [...dateOptions];
                    tmpOptions.push({value: dateValue, label: dateValue});
                    tmpOptions.sort((a, b) => a.value > b.value ? -1 : 1);
                    setDateOptions(tmpOptions);
                }
                break;
            default:
            //
        }

        setDate(date);

        refreshConsensusList(clientIds, date.value);
    }

    const changeUnpublishChecked = () => {
        setUnpublish(!unpublish);
    }

    const changeSkipReview = () => {
        setSkipReview(!skipReview);
    }

    const changeNotifyReviewer = () => {
        setNotifyReviewer(!notifyReviewer);
    }

    const onConsensusChange = (consensus, action) => {
        setConsensusOption(consensus);
    }

    // Whenever the client dropdown becomes too large
    // const CustomMenuList = (props) => {
    //     const itemHeight = 35;
    //     const { options, children, maxHeight, getValue } = props;
    //     const [value] = getValue();
    //     const initialOffset = options.indexOf(value) * itemHeight;
    //
    //     return (
    //         <div>
    //             <List
    //                 style={{ height: "max-content", maxHeight: maxHeight }}
    //                 height={240}
    //                 itemCount={children.length}
    //                 itemSize={itemHeight}
    //                 initialScrollOffset={initialOffset}
    //             >
    //                 {({ index, style }) => <div style={style}>{children[index]}</div>}
    //             </List>
    //         </div>
    //     );
    // };

    let content;
    if (loadStatus === "error") {
        content = <div className="main-content">
            <header className="jumbotron">
                <h3 className='canopia'>Error</h3>
                <p>{loadMessage}</p>
            </header>
        </div>
    } else if (loadStatus !== "success") {
        content = <div><br/><img alt="loading" src={ajaxloader}/></div>;
    } else {

        content =
            <Card className={'canopia-run-card'} style={{width: '40rem'}}>
                <Card.Body>
                    <Card.Title className='canopia-card-title'>Run - Evaluate a portfolio on a specific date</Card.Title>

                    <form onSubmit={handleRun}>
                        <div className="form-group">
                            <label>Client</label>
                            <Select options={clientOptions}
                                    isClearable
                                    isSearchable={true}
                                    closeMenuOnSelect={false}
                                    onChange={handleSelectClient}
                                    isMulti/>
                            {/*<Select*/}
                            {/*    options={clientOptions}*/}
                            {/*    components={{*/}
                            {/*        MenuList: CustomMenuList*/}
                            {/*    }}*/}
                            {/*    isClearable*/}
                            {/*    isSearchable={true}*/}
                            {/*    closeMenuOnSelect={false}*/}
                            {/*    onChange={handleSelectClient}*/}
                            {/*    isMulti*/}
                            {/*/>*/}
                        </div>
                        {clientIds.length > 0 && loadingClientDates && <div><img alt="loading" src={ajaxloader}/></div>}
                        {clientIds.length > 0 && !loadingClientDates && !dateMessages && <>
                            <br/>
                            <div className="form-group">
                                <label>Portfolio Date</label>
                                <Select options={dateOptions}
                                        placeholder={'yyyy-MM-dd'}
                                        name={'date-select'} //
                                        value={date}
                                        closeMenuOnSelect={true}
                                        onChange={handleDateChange}/>
                                <div style={{marginTop: "8px"}}>
                                    Available portfolio dates taken from the uploaded portfolios (Admin -> Import ->
                                    Global Custody)
                                </div>
                                <div>
                                    When multiple clients are selected, the available dates are the ones shared amongst
                                    all the clients
                                </div>
                            </div>
                        </>}
                        {clientIds.length > 0 && dateMessages && (
                            <div className={"canopia-error"}>
                                {dateMessages.map(message => {
                                    return <div className={"import_log_" + message.key}>{message.value}</div>
                                })}
                            </div>
                        )}
                        {clientIds.length > 0 && loadingConsensusList &&
                            <div><img alt="loading" src={ajaxloader}/></div>}
                        {clientIds.length > 0 && !loadingConsensusList && !consensusMessages && <>
                            <br/>
                            <div className="form-group">
                                <label>Consensus</label>
                                <Select options={consensusOptions}
                                        placeholder={'Select a consensus'}
                                        name={'source-select'}
                                        value={consensusOption}
                                        closeMenuOnSelect={true}
                                        onChange={onConsensusChange}/>
                            </div>
                        </>
                        }
                        {clientIds.length > 0 && consensusMessages && (
                            <div className={"canopia-error"}>
                                {consensusMessages.map(message => {
                                    return <div className={"import_log_" + message.key}>{message.value}</div>
                                })}
                            </div>
                        )}
                        <br/>
                        <div className="form-group">
                            <span onClick={changeUnpublishChecked} style={{marginRight: '1rem'}}>
                                {unpublish ? <CheckSquareFill color={'#adad2f'} size={'1.4em'}/> :
                                    <Square color={'#adad2f'} size={'1.4em'}/>}
                            </span>
                            <label>Unpublish</label>
                        </div>
                        <br/>
                        <div className="form-group">
                            <label>Run type</label>
                            <div style={{margin: '15px'}}>
                                <FormCheck type="radio" label="Initial"
                                           checked={runType === "full_eval_initial_run"}
                                           onChange={() => changeRunType("full_eval_initial_run")}/>
                                <FormCheck type="radio" label="Review"
                                           checked={runType === "full_eval_final_run"}
                                           onChange={() => changeRunType("full_eval_final_run")}/>
                                <FormCheck type="radio" label="CO2 update"
                                           checked={runType === "co2_update"}
                                           onChange={() => changeRunType("co2_update")}/>
                            </div>
                        </div>

                        {runType === "full_eval_initial_run" &&
                            <div className="form-group">
                                <span onClick={changeNotifyReviewer} style={{marginRight: '1rem'}}>
                                    {notifyReviewer ? <CheckSquareFill color={'#adad2f'} size={'1.4em'}/> :
                                        <Square color={'#adad2f'} size={'1.4em'}/>}
                                </span>
                                Notify the reviewer that the initial run is completed and the review is
                                available.
                            </div>
                        }

                        {runType === "full_eval_final_run" && <>
                            <div className="form-group">
                                <span onClick={changeSkipReview} style={{marginRight: '1rem'}}>
                                    {skipReview ? <CheckSquareFill color={'#adad2f'} size={'1.4em'}/> :
                                        <Square color={'#adad2f'} size={'1.4em'}/>}
                                </span>
                                Skip the review step, use the current matching in the positions (reviewed or not).
                                Typical usage: when one wants to keep the same matching but use another consensus.
                            </div>
                            <br/>
                            <p>The review run requires 2 more parameters:</p>
                            <ul>
                                <li>The filename of the review made by Conser</li>
                                <li>The type of review to apply: By "position ID" if available or by "ISIN and name" in
                                    case
                                    you need to apply the review made for another client ID
                                </li>
                            </ul>
                            <div className="form-group">
                                <label>Review Filename (leave it blank if there is only 1 file available in the
                                    directory)</label>
                                <input value={reviewFileName}
                                       placeholder="e.g. Demo Global Portfolio By Asset Class_20221230 RevisedJL.csv"
                                       className={'form-control'}
                                       aria-label="Review Filename"
                                       onChange={(event) => setReviewFileName(event.target.value)}
                                       aria-describedby="basic-addon2"/>
                            </div>
                            <br/>
                            <div className="form-group">
                                <label>Review Type</label>
                                <DropdownButton id="dropdown-basic-button" title={reviewType} value={reviewType}
                                                variant={'default-dropdown'}>
                                    {reviewTypes.map(v => (
                                        v !== reviewType &&
                                        <DropdownItem key={v} value={v} onClick={() => setReviewType(v)}
                                                      bsPrefix={'canopia-dropdown-item'}>
                                            <span style={{fontWeight: 'normal'}}>{v}</span>
                                        </DropdownItem>
                                    ))}
                                </DropdownButton>
                            </div>
                        </>}
                        <br/>
                        <div className="form-group">
                            <button className="btn btn-primary btn-block" disabled={loading}>
                                {loading && (
                                    <span className="spinner-border spinner-border-sm" style={{marginRight: '5px'}}/>
                                )}
                                <span>Run</span>
                            </button>
                        </div>

                        {loading &&
                            <MessageBox title={'Info'} message={'The job is running, you may leave this page.'}/>}

                        {jobResults &&
                            <div className={"alert import_log"}>
                                {jobResults.logs.map(message => {
                                    return <div className={"import_log_" + message.key}>{message.value}</div>
                                })}
                                <br/>
                                {jobResults.results.map(result => {
                                    return result.logs.map(log => {
                                            return <div className={"import_log_" + log.key}>{log.value}</div>
                                        }
                                    )
                                })}
                            </div>
                        }

                        {errorName && (
                            <div className="form-group">
                                <div className={"alert alert-danger"} role="alert">
                                    <h3 className='canopia'>{errorName}</h3>
                                    {errorMessage}
                                    {errors && errors.map(error => {
                                        return <li key={error.field}>{error.defaultMessage && error.defaultMessage}</li>
                                    })
                                    }
                                </div>
                            </div>
                        )}
                    </form>
                </Card.Body>
            </Card>
    }

    return (
        <>
            <div>
                {content}
            </div>
            <Modal
                show={showModal}
                onHide={() => hideModal()}
                backdrop="static"
                keyboard={false}
                size={"lg"}
                aria-labelledby="terms-and-conditions"
                scrollable={true}
            >
                <Modal.Body>
                    <div className={"alert " + modalClass}>
                        {modalMessages && modalMessages.length > 0 && modalMessages.map(message => {
                            return <div>{message}</div>
                        })}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => hideModal()}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
